import React from "react";
import { ErrorIcon } from "../components/svgs";
import { Button, StyledText } from "../components/common";
import styled from "styled-components";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ErrorPage = ({
  title = "Oops! Trouble Logging In",
  description = "We're facing some technical issues at the moment. Please try logging in again in a few minutes.",
}) => {
  //   const history = useHistory();

  const onButtonClick = () => {
    
  };

  return (
    <MainContainer>
      <ContentWrapper>
        <IconWrapper>
          <ErrorIcon />
        </IconWrapper>
        <TitleText>{title}</TitleText>
        <DescriptionText>{description}</DescriptionText>
        {/* <FixedButton onClick={onButtonClick}>
          <ButtonText color="#333">Ok</ButtonText>
        </FixedButton> */}
      </ContentWrapper>
    </MainContainer>
  );
};

export default ErrorPage;

const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 0 52px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const IconWrapper = styled.div`
  margin-bottom: 15px;
`;

const TitleText = styled(StyledText)`
  color: #333333;
  font-family: "MTNBold";
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 10px;
`;

const DescriptionText = styled(StyledText)`
  color: #333333;
  font-family: "MTNRegular";
  font-size: 14px;
`;

const FixedButton = styled(Button)`
  position: fixed;
  bottom: 50px;
  width: calc(100% - 64px);
  max-width: 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 24px;
  background-color: #ffcc00;
`;

const ButtonText = styled(StyledText)`
  color: #333;
  font-weight: bold;
`;
